import { Link } from "react-router-dom";

function EULA() {
    return (
        <div className="policy-container">
            <h1>QAPfinancials End User License Agreement</h1>
            <p><strong>Effective Date:</strong> September 21, 2025</p>
            <p>
            This End User License Agreement (“Agreement”) is a legal agreement between you (“User,” “you”) 
            and QAPfinancials LLC (“Company,” “we,” “our,” or “us”) governing your use of our software (“Software”).
            By installing, accessing, or using the Software, you agree to be bound by this Agreement. 
            If you do not agree, do not use the Software.
            </p>
            <p><strong>1. License Grant</strong></p>
            <p>We grant you a limited, non-exclusive, non-transferable, revocable 
                license to install and use the Software solely for your internal 
                business purposes in accordance with this Agreement.
            </p>
            <p><strong>2. Restrictions</strong></p>
            <p>You may not:
                <ul>
                    <li>Copy, modify, or create derivative works of the Software.</li>
                    <li>Reverse engineer, decompile, or disassemble the Software.</li>
                    <li>Rent, lease, sell, sublicense, or distribute the Software.</li>
                    <li>Use the Software in any manner that violates applicable laws or third-party rights.</li>
                </ul>
            </p>
            <p><strong>3. QuickBooks Integration</strong></p>
            <p>The Software connects to QuickBooks via Intuit’s API. By using this feature, you acknowledge and agree:
                <ul>
                    <li>Your use of QuickBooks is subject to Intuit’s terms and policies.</li>
                    <li>We are not responsible for QuickBooks’ services, data availability, or security.</li>
                    <li>You authorize us to access and process data from your QuickBooks account solely to provide the Software’s functionality.</li>
                </ul>
            </p>
            <p><strong>4. Ownership</strong></p>
            <p>The Software is licensed, not sold. All rights, title, and interest in the Software remain with [Your Company Name].</p>
            <p><strong>5. Data & Privacy</strong></p>
            <p>Your use of the Software is subject to our Privacy Policy, which explains how we handle your information.</p>
            <p><strong>6. Updates</strong></p>
            <p>We may provide updates, patches, or new versions of the Software. These are governed by this Agreement unless we provide different terms.</p>
            <p><strong>7. Disclaimer of Warranties</strong></p>
            <p>The Software is provided “AS IS” and “AS AVAILABLE.” We disclaim all warranties, express or implied, including but not limited to merchantability, fitness for a particular purpose, and non-infringement.</p>
            <p><strong>8. Limitation of Liability</strong></p>
            <p>To the fullest extent permitted by law, [Your Company Name] shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of the Software. Our total liability shall not exceed the amount you paid for the Software in the past 12 months.</p>
            <p><strong>9. Termination</strong></p>
            <p>We may suspend or terminate your license if you violate this Agreement. Upon termination, you must stop using the Software and destroy all copies.</p>
            <p><strong>10. Governing Law</strong></p>
            <p>This Agreement is governed by the laws of [Insert State/Country], without regard to conflict of law principles.</p>
            <p><strong>11. Entire Agreement</strong></p>
            <p>This Agreement constitutes the entire agreement between you and us regarding the Software and supersedes all prior understandings.</p>
            <p><strong>12. Contact</strong></p>
            <p>For questions about this Agreement, contact:
                <p>Noah Isaacs</p>
                <p>noahbisaacs@gmail.com</p>
                <p>31-00 Broadway 3rd Floor, Fair Lawn NJ 07410</p>
            </p>
            <Link to="/" className="home-link">Go Back Home</Link>
            
        </div>
    )
}

export default EULA;